"use strict";

var _objectWithoutProperties = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _MarkdownRenderer = require("./MarkdownRenderer.style");

var MarkdownRenderer = function MarkdownRenderer(_ref) {
  var copySize = _ref.copySize,
      html = _ref.html,
      rest = _objectWithoutProperties(_ref, ["copySize", "html"]);

  var copy = html && html.replace(/\\n/g, '\n') || '';
  return /*#__PURE__*/_react.default.createElement(_MarkdownRenderer.Wrapper, Object.assign({
    copySize: copySize,
    dangerouslySetInnerHTML: {
      __html: copy
    },
    textAlign: "center"
  }, rest));
};

MarkdownRenderer.propTypes = {
  copySize: _propTypes.default.string,
  html: _propTypes.default.string
};
MarkdownRenderer.defaultProps = {
  copySize: 'medium',
  html: ''
};
var _default = MarkdownRenderer;
exports.default = _default;